import React, { memo, useCallback } from 'react';
import Heading from '@/shared/Heading';
import Map from '@/components/Map';
import Container from '@/shared/Container';
import PersonalisedWidget from '@/shared/crisp/PersonalisedWidget';
import withContentFlags from '@/hoc/withContentFlags';

interface HelpDeviceProps {
  title: string;
  list: any[];
}

const HelpDevice = (props: HelpDeviceProps) => {
  const { title, list } = props;

  const render = useCallback((item: any, index: number) => {
    return (
      <PersonalisedWidget
        key={item.id}
        dataTestId={`help-device-${item.id}`}
        index={index}
        {...item}
      />
    );
  }, []);

  return (
    <Container className="py-s6 md:py-s7">
      <Heading
        level={3}
        className="text-h-3 md:text-hd-3 md:text-center font-extrabold"
        text-cm-primary
      >
        {title}
      </Heading>
      <Map
        className="mt-s6 grid grid-cols-2 md:flex gap-s5 md:gap-s6 justify-center"
        list={list}
        render={render}
      />
    </Container>
  );
};

export default withContentFlags(memo(HelpDevice));
